/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getEspecialties } from 'app/entities/especialty/especialty.reducer';
import { getEntities as getSymptoms } from 'app/entities/symptom/symptom.reducer';
import { getEntities as getChronicConditions } from 'app/entities/chronic-condition/chronic-condition.reducer';
import { createEntity, getEntity, reset, updateEntity } from './speciality-symptom-preferences.reducer';

export const SpecialitySymptomPreferencesUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const especialties = useAppSelector(state => state.especialty.entities);
  const symptoms = useAppSelector(state => state.symptom.entities);
  const chronicConditions = useAppSelector(state => state.chronicCondition.entities);
  const specialitySymptomPreferencesEntity = useAppSelector(state => state.specialitySymptomPreferences.entity);
  const loading = useAppSelector(state => state.specialitySymptomPreferences.loading);
  const updating = useAppSelector(state => state.specialitySymptomPreferences.updating);
  const updateSuccess = useAppSelector(state => state.specialitySymptomPreferences.updateSuccess);

  const handleClose = () => {
    navigate(`/speciality-symptom-preferences${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getEspecialties({}));
    dispatch(getSymptoms({}));
    dispatch(getChronicConditions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...specialitySymptomPreferencesEntity,
      ...values,
      speciality: especialties.find(it => it.id.toString() === values.speciality?.toString()),
      symptom: symptoms.find(it => it.id.toString() === values.symptom?.toString()),
      condition: chronicConditions.find(it => it.id.toString() === values.condition?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...specialitySymptomPreferencesEntity,
          speciality: specialitySymptomPreferencesEntity?.speciality?.id,
          symptom: specialitySymptomPreferencesEntity?.symptom?.id,
          condition: specialitySymptomPreferencesEntity?.condition?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.specialitySymptomPreferences.home.createOrEditLabel"
            data-cy="SpecialitySymptomPreferencesCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.home.createOrEditLabel">
              Create or edit a SpecialitySymptomPreferences
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="speciality-symptom-preferences-id"
                  label={translate('tinyMedicRestApp.specialitySymptomPreferences.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.active')}
                id="speciality-symptom-preferences-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.draft')}
                id="speciality-symptom-preferences-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.cursor')}
                id="speciality-symptom-preferences-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.lastUpdated')}
                id="speciality-symptom-preferences-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.microSec')}
                id="speciality-symptom-preferences-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.timestampEntry')}
                id="speciality-symptom-preferences-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.aSymptom')}
                id="speciality-symptom-preferences-aSymptom"
                name="aSymptom"
                data-cy="aSymptom"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.aCondition')}
                id="speciality-symptom-preferences-aCondition"
                name="aCondition"
                data-cy="aCondition"
                check
                type="checkbox"
              />
              <ValidatedField
                id="speciality-symptom-preferences-speciality"
                name="speciality"
                data-cy="speciality"
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.speciality')}
                type="select"
              >
                <option value="" key="0" />
                {especialties
                  ? especialties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="speciality-symptom-preferences-symptom"
                name="symptom"
                data-cy="symptom"
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.symptom')}
                type="select"
              >
                <option value="" key="0" />
                {symptoms
                  ? symptoms.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="speciality-symptom-preferences-condition"
                name="condition"
                data-cy="condition"
                label={translate('tinyMedicRestApp.specialitySymptomPreferences.condition')}
                type="select"
              >
                <option value="" key="0" />
                {chronicConditions
                  ? chronicConditions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/speciality-symptom-preferences"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SpecialitySymptomPreferencesUpdate;
